<template>
  <v-card outlined class="backoffice-table" style="box-shadow: none !important">
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      hide-default-footer
      @page-count="pageCount = $event"
      @update:page="requestPage($event)"
      class="elevation-1"
      :loading="loading"
      :mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat color="transparent">
          <v-spacer></v-spacer>
          <v-text-field
            class="search-feild"
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Pesquisar por"
            dense
            solo
            flat
            filled
            hide-details
            @keydown.enter="getItems(0, itemsPerPage)"
          ></v-text-field>
          <!-- Create/Edit Dialog -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            content-class="backoffice-dialog"
            scrollable
          >
            <!-- Dialog Button -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="primary"
                height="40"
                v-bind="attrs"
                v-on="on"
                @click="
                  editedItem = $lodash.cloneDeep(emptyItem);
                  dialogTitle = 'Adicionar Competição';
                "
                >Adicionar Competição</v-btn
              >
            </template>
            <v-card>
              <!-- Close X button -->
              <v-toolbar flat color="#EBEFF3">
                <v-btn
                  icon
                  @click="dialog = false"
                  class="close-btn"
                  color="#9AABB8"
                  height="40"
                  width="40"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- Input text fields -->
              <v-row style="overflow-y: auto">
                <v-col cols="12" class="dialog-frame">
                  <div class="dialog-title">{{ dialogTitle }}</div>

                  <v-row>
                    <v-col>
                      <div class="dialog-label">Nome</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.name"
                        :hide-details="!input.name.error"
                        :error-messages="input.name.errorText"
                        @input="
                          validateInput(editedItem.name, input.name, false)
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <div class="dialog-label">Descrição</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.description"
                        :hide-details="!input.description.error"
                        :error-messages="input.description.errorText"
                        @input="
                          validateInput(
                            editedItem.description,
                            input.description,
                            false
                          )
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">País</div>
                      <v-select
                        @input="
                          validateInput(
                            editedItem.country,
                            input.country,
                            false
                          )
                        "
                        :items="countries"
                        item-text="name"
                        item-value="id"
                        v-model="editedItem.country"
                        background-color="#D8E0E6"
                        color="#9aabb8"
                        solo
                        flat
                        height="40"
                        :hide-details="!input.country.error"
                        :error-messages="input.country.errorText"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Modalidade</div>
                      <v-select
                        @input="
                          validateInput(editedItem.sport, input.sport, false)
                        "
                        :items="sports"
                        item-text="name"
                        item-value="id"
                        v-model="editedItem.sport"
                        background-color="#D8E0E6"
                        color="#9aabb8"
                        solo
                        flat
                        height="40"
                        :hide-details="!input.sport.error"
                        :error-messages="input.sport.errorText"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Card Actions / Footer button -->
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  tile
                  depressed
                  @click="validate()"
                  :loading="loading"
                  >Submeter</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- Actions -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          depressed
          dark
          color="#D8E0E6"
          class="gray-button"
          @click="editItem(item)"
          style="margin-right: 8px"
          >Editar</v-btn
        >
        <RemoveItem
          :target="'competição'"
          @remove-item="deleteItem(item)"
        ></RemoveItem>
      </template>
      <!-- BODY APPEND -->
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in itemsPerPage - items.length" :key="'tr-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
    <div class="pagination">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<style scoped>
.v-input >>> .v-text-field__details {
  padding: 0 !important;
}
.v-input >>> .v-input__control {
  display: table;
}
@media only screen and (max-width: 768px) {
  .backoffice-table >>> .v-data-table__wrapper {
    overflow: auto;
  }
  .backoffice-table >>> table {
    width: 876px;
  }
}
</style>

<script>
import Vue from "vue";
import RemoveItem from "@/components/RemoveItem";
import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "CompetitionsTable",
  components: {
    RemoveItem,
  },
  props: { data: {} },
  data: () => ({
    dialog: false,
    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    headers: [
      { text: "Nome", value: "name", sortable: false },
      { text: "Descrição", value: "description", sortable: false },
      { text: "País", value: "country.name", sortable: false },
      { text: "Modalidade", value: "sport.name", sortable: false },
      { text: "", align: "end", value: "actions", sortable: false },
    ],
    sports: [],
    countries: [],
    items: [],
    totalItems: 0,
    dialogTitle: "",
    editedItem: {
      name: "",
      description: "",
      country: "",
      sport: {},
    },
    emptyItem: {
      name: "",
      description: "",
      country: "",
      sport: "",
    },
    input: {
      name: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
      description: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
      country: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
      sport: {
        value: "",
        valid: false,
        error: false,
        errorText: "",
      },
    }
  }),
  methods: {
    getFrontendLists() {
      ApiService.getGraphQLFrontendLists().then(
        (response) => {
          const data = response.data.data.getCountriesAndSports;
          this.sports = data.sports;
          this.countries = data.countries;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getItems(page, size) {
      this.loading = true;
      ApiService.getCompetitions(this.search, page, size).then(
        (response) => {
          const data = response.data;
          this.items = data.competitions;
          this.totalItems = data.totalElements;
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    saveItem() {
      this.loading = true;
      ApiService.saveCompetition(this.editedItem).then(
        (response) => {
          this.dialog = false;
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    deleteItem(item) {
      this.loading = true;
      ApiService.deleteCompetition(item.name).then(
        (response) => {
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    editItem(item) {
      this.dialogTitle = "Editar modalidade";
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    requestPage(page) {
      this.getItems(page - 1, this.itemsPerPage);
    },
    validate() {
      const validName = this.validateInput(
        this.editedItem.name,
        this.input.name,
        true
      );
      const validDescription = this.validateInput(
        this.editedItem.description,
        this.input.description,
        true
      );
      const validCountry = this.validateInput(
        this.editedItem.country,
        this.input.country,
        true
      );
      const validSport = this.validateInput(
        this.editedItem.sport,
        this.input.sport,
        true
      );
      if (validName && validDescription && validCountry && validSport) {
        this.saveItem();
      }
    },
    validateInput(item, input, fromButton) {
      if (item != "") {
        input.valid = true;
        input.error = false;
        input.errorText = null;
        return true;
      } else {
        input.valid = false;
        if (fromButton) {
          input.error = true;
          input.errorText = "Campo obrigatório!";
        }
        return false;
      }
    }
  },
  created() {
    this.getFrontendLists();
  },
  mounted() {
    this.getItems(0, this.itemsPerPage);
  },
});
</script>